import React,{ Component } from 'react'
import { Container,Table,Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

class EditOfficer extends Component{
  constructor(props) {
    super(props);
    this.state = {
      Officer : {},
    }
  }
  componentWillMount() {
    axios.get(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        params: {
          'action': 'viewAllOfficer',
        },
      }
    ).then(res => {
      console.log(res);
      this.setState({ Officer : res.data })
    })
  }

    handleTableRow = (e) => {
      console.log(e.target.parentElement.parentElement.id)
   
      let targetID = e.target.parentElement.parentElement.id
      let currentState = this.state
      let newState = { ...currentState,target : targetID }
      this.setState(newState,() => {
        this.handleDelete()
      })
      console.log(this.state)
        
    }
    
    handleDelete = () => {
      fetch('https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',{ method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },body: JSON.stringify({
          'action' : 'deleteOfficer',
          'data' : {
            'userID' : this.state.target,
          },
        }) })
        .then(res => res.json()).then(data => {console.log(data)
          axios.get(
            'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
            {
              params: {
                'action': 'viewAllOfficer',
              },
            }
          ).then(res => {
            console.log(res);
            this.setState({ Officer : res.data })
          })
        })
    }
    
    render(){
      return(
        <Container className="Edit">
          <div>&nbsp;</div>
          <Link to="AdminSys">back</Link>
          <h2>แก้ไขข้อมูลเจ้าหน้าที่</h2>
          <Table bordered hover>
            <thead>
              {Object.keys(this.state.Officer).map((a,idx) => {
                if(idx===0){
                  return(<tr>{Object.keys(this.state.Officer[a]).map((res) => (
                        
                    <th>{res}</th>
                        
                        
                  ))}<th></th></tr>)}})}
            </thead>
            <tbody>
              {Object.keys(this.state.Officer).map((a) => {
                let c = this.state.Officer[a]
                return(<tr id={c.ID} onClick={this.handleTableRow}>{Object.keys(this.state.Officer[a]).map((res) => (
                        
                  <td>{c[res]}</td>
                        
                        
                ))}<td><Button variant="outline-danger" id ="Button1">reset</Button><Button variant="danger" id ="Button1" onClick={this.handleDelete}>Delete</Button></td></tr>)
           
              }
              )
              }
        
            </tbody>
          </Table>
        </Container>
      )
    }
}

export default EditOfficer;
